<!-- @if(isWeb){ -->
@if (isLoading$ | async) {
<div class="loading-overlay-new">
    <div class="row">
        <div class="spinner-mini">
            <div class="ring-mini"></div>
            <div class="ring-mini"></div>
            <div class="ring-mini"></div>
        </div>
    </div>

</div>
}

<!-- @if ((isInstallable$ | async) && !(isLoading$ | async)) {
<div class="pwa-style">
    <ngb-toast header="Instalación APP" [autohide]="false">
        <div>ODONTO ARCO <br>
            no está instalado en este dispositivo.</div>
        <br>
        <button class="btn btn-primary" (click)="installPwa()">Instalar</button>
    </ngb-toast>
</div>
} -->

<!-- @if (!(isInstallable$ | async) && !(isLoading$ | async)) { -->
<router-outlet />
<app-notification-modal></app-notification-modal>
<!-- } -->
<!-- } -->
<!-- @if(isMobile){
@if (isLoading$ | async) {
<div class="loading-overlay"> -->
<!-- Cargando... Puedes reemplazar esto con un spinner u otro indicador -->
<!-- </div>
}

@if ((isInstallable$ | async) && !(isLoading$ | async)) {
<div class="pwa-style">
    <ngb-toast header="Instalación APP" [autohide]="false">
        <div>ODONTO ARCO <br>
            no está instalado en este dispositivo.</div>
        <br>
        <button class="btn btn-primary" (click)="installPwa()">Instalar</button>
    </ngb-toast>
</div>
}

@if (!(isInstallable$ | async) && !(isLoading$ | async)) {
<router-outlet />
}
} -->